import { searchParametersActions } from 'features/searchResultsFacets';
import Select from '@components/select';
import { store, store$ } from '@redux/store';
import { distinctUntilChanged, map } from 'rxjs';
import { selectGarages } from '../redux/selectors';

const select = document.querySelector('[data-garages-filter]');
const garages$ = new Select(select).getObservable();
const setValue = (value) => {
  select.value = value || 0;
};

garages$.subscribe((value) => {
  store.dispatch(searchParametersActions.fetchGarages(value));
});

store$.pipe(map(selectGarages), distinctUntilChanged()).subscribe(setValue);
